module.exports = __webpack_public_path__ + "static/woman-coding-bfa7dd5684894997dc71c662b330ff98.jpg";